module.exports = __webpack_public_path__ + "img/mask-group-24@1x.3a1ff057.png";